import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex, Text as BaseText, ButtonFilled, Link, Image } from '../Base';
import { SPACE } from '../Theme';

const ImageWrapper = styled(Box)`
  margin: 0 auto;
  max-width: 80vw;
  @media (min-width: 768px) {
    max-width: 30vw;
  }
`;

const Text = (props) => <BaseText textStyle={'heading4'} fontWeight={'normal'} {...props} />;

const NoMatch = ({ onCourseClick, ...props }) => {
  return (
    <Flex flexDirection="column" alignItems="center" p={SPACE.lg}>
      <ImageWrapper>
        <Image src="/assets/images/not_found.png" />
      </ImageWrapper>
      <Text mt={2}>
        Error
        <Text fontWeight="bold" as="span">
          {` 404 `}
        </Text>
        ไม่พบหน้านี้
      </Text>
      <Box mt={4}>
        <ButtonFilled onClick={onCourseClick}>กลับสู่หน้าคอร์สเรียนของฉัน</ButtonFilled>
      </Box>
      <Box mt={2}>
        <Link as="a" href="http://www.ondemand.in.th" target="_blank" color="primary">
          ไปสู่จักรวาล OnDemand
        </Link>
      </Box>
    </Flex>
  );
};

NoMatch.propTypes = {
  onCourseClick: PropTypes.func,
};

NoMatch.defaultProps = {
  onCourseClick: () => {},
};

export default NoMatch;
